import { apiInterfaceForJson } from '../common/apiManager';

export const getAllSamplesData = (params = {}) => {
    return apiInterfaceForJson('/order/v1/all_samples', 'POST', params);
};
